import React from 'react';
import { Link } from 'react-router-dom';
import { useRecentlyViewed } from '../../context/ProductContext';
import { getProductThumb } from '../../data/productImages';
import { ArrowRight, Clock, X } from 'lucide-react';

interface RecentlyViewedProps {
  /** Esclude questo SKU dalla lista (es. il prodotto attualmente visualizzato). */
  excludeSku?: string;
  /** Titolo sezione personalizzato. */
  title?: string;
}

export function RecentlyViewed({ excludeSku, title = 'Visti di Recente' }: RecentlyViewedProps = {}) {
  const { recentProducts, clearRecent } = useRecentlyViewed();
  const filtered = excludeSku ? recentProducts.filter(p => p.sku !== excludeSku) : recentProducts;

  if (filtered.length === 0) return null;

  return (
    <section className="py-8 border-t" data-testid="recently-viewed">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold flex items-center gap-2"><Clock className="w-4 h-4 text-muted-foreground" /> {title}</h2>
          <button onClick={clearRecent} className="text-xs text-muted-foreground hover:text-foreground">Cancella cronologia</button>
        </div>
        <div className="flex gap-3 overflow-x-auto pb-2">
          {filtered.slice(0, 8).map(p => (
            <Link key={p.sku} to={`/prodotti/${p.category}/${p.sku}`} className="flex-shrink-0 w-36 rounded-xl border bg-white p-3 hover:border-[hsl(var(--dtk-focus))] transition-colors group">
              <img src={getProductThumb(p.sku, p.category).replace('w=80', 'w=200')} alt={p.sku} className="w-full h-20 rounded-lg object-contain bg-white border p-1 mb-2" loading="lazy" />
              <div className="text-[13px] lg:text-[10px] font-mono font-bold text-[hsl(214,58%,41%)]">{p.sku}</div>
              <div className="text-[13px] lg:text-[10px] text-muted-foreground truncate group-hover:text-foreground">{p.brand}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
